import {
  RESET,
  SET_SNACKBAR,
  SET_AXIOS_ERROR,
  SET_LOADING
} from "../../utils/constants";

const initialState = () => ({
  loading: false,
  message: "",
  isError: false
});

const state = {
  ...initialState()
};

const getters = {
  color: state => (state.isError ? "red" : "green")
};

Object.keys(state).forEach(key => {
  Object.assign(getters, {
    [key]: state => state[key]
  });
});

const actions = {
  setMessage({ state, commit }, { message, showSnackbar, isError }) {
    commit(SET_AXIOS_ERROR, message);
    commit(SET_SNACKBAR, showSnackbar, { root: true });
    state.isError = isError;
  }
};

const mutations = {
  [RESET](state) {
    Object.assign(state, initialState());
  },
  [SET_LOADING](state, payload) {
    state.loading = payload;
  },
  [SET_AXIOS_ERROR](state, message) {
    state.message = message;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
